import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import y from 'y4/Utils';

/**
 *
 * Like AdvanceFilter is a single filter component for other panels.
 *
 * @param {*} param
 * @returns
 */

const SingleFilter = ({ form, panel }) => {
  const [data, setData] = useState();

  //Dispatch selectionChanged
  const filterChanged = s => {
    form.eventTarget.dispatchEvent(
      new CustomEvent('form-event', {
        detail: {
          event: 'filterChanged',
          panel,
          form,
          data: s
        }
      })
    );
  };

  const search = s => {
    form.eventTarget.dispatchEvent(
      new CustomEvent('form-event', {
        detail: {
          event: 'search',
          panel,
          form,
          data: s
        }
      })
    );
  };

  const setDataAndDispatch = value => {
    setData(value);
    filterChanged(value);
  };

  //Listen events
  useEffect(() => {
    form.eventTarget.addEventListener('form-event', e => {
      const event = e.detail.event;
      const path = 'events.listen' + y.firstCharToUpper(event);
      const script = y.gpv(panel, path);
      if (script) {
        const f = Function('y', 'source', 'target', script);
        f(y, e.detail, {
          form,
          panel,
          data,
          setData,
          setDataAndDispatch
        });
      }
    });
  }, [form.eventTarget]);

  return (
    <div className="d-lg-flex justify-content-between">
      <Row className="flex-between-center gy-2">
        <Col xs="auto">
          <AdvanceTableSearchBox
            globalFilter={data}
            setGlobalFilter={setDataAndDispatch}
            search={search}
          />
        </Col>
      </Row>
    </div>
  );
};

SingleFilter.propTypes = {
  form: PropTypes.object,
  panel: PropTypes.object
};

export default SingleFilter;
